import * as multiplikActions from '../actions/multiplik-actions';

const initialState = {
  signature: null,
  invitationLink: null,
  invitations: null,
};

export default function multiplik(state = initialState, action) {
  switch (action.type) {
    case multiplikActions.MULTIPLIK_SIGNATURE_SUCCESS:
      return {
        ...state,
        signature: action.payload,
      };
    case multiplikActions.MULTIPLIK_SIGNATURE_FAILURE:
      return {
        ...state,
        signature: null,
      };
    case multiplikActions.MULTIPLIK_SIGN_SUCCESS:
      return {
        ...state,
        signature: action.payload,
      };
    case multiplikActions.MULTIPLIK_SIGN_FAILURE:
      return {
        ...state,
        signature: null,
      };
    case multiplikActions.MULTIPLIK_INVITATION_LINK_SUCCESS:
      return {
        ...state,
        invitationLink: action.payload,
      };
    case multiplikActions.MULTIPLIK_INVITATIONS_SUCCESS:
      return {
        ...state,
        invitations: action.payload,
      };
    default:
      return { ...state };
  }
}
